import { paymentMethod as PaymentMethods } from '@ourbranch/lookups';
import { appConfig } from 'brand-config';

/**
 * Direct-bill ('D') is a mutual-only AUTO payment method. Migrated mutual auto policies (CFM) come in
 * as Direct pay and need it; Branch/BIX retail auto must never offer it. The brand flag
 * `featureFlags.autoDirectBillPaymentMethod` is on for the mutual brands that write auto (CFM), off for
 * Branch (#35123). Every auto payment-method dropdown — offer settings, the policy Billing tab, its
 * renewal counterpart — must run its option list through `filterAutoDirectBillOptions` so Direct only
 * ever appears for the mutuals, and the backend re-checks the same rule at bind (pre-bind-validations).
 */
export const isAutoDirectBillAllowed = () => Boolean(appConfig?.featureFlags?.autoDirectBillPaymentMethod);

// Drop Direct ('D') from an AUTO payment-method option list unless the brand enables auto direct bill.
// Callers pass only auto lists here; farm lists Direct for every brand and is not routed through this.
export const filterAutoDirectBillOptions = (options = []) =>
  isAutoDirectBillAllowed() ? options : options.filter((option) => option.id !== PaymentMethods.Direct);
